import { injectIntl } from 'react-intl';
import { formValues } from 'utils/formValues';
import SpecificsOptions from './SpecificsOptions';
import config from './config';

export const CONFIG = config;

export default injectIntl(formValues('hasExperience', 'marginAccountSelected')(SpecificsOptions));
